import React, { useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import layoutBgImg from '../../Images/layout/others.jpg'
import { useTranslation } from 'react-i18next'
import {
  Password, Phone
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import GlobalLayout from '../../Component/layout/global-layout';

const Login = () => {
  const { t } = useTranslation()
  const [phoneNumber, setPhoneNumber] = useState('+993');
  const [password, setPassword] = useState('')

  const handlePhoneNumberChange = (e) => {
    let input = e.target.value;
    if (!input.startsWith('+993')) {
      input = '+993' + input.replace(/[^0-9]/g, '');
    } else {
      input = '+993' + input.slice(4).replace(/[^0-9]/g, '');
    }
    if (input.length > 12) {
      input = input.slice(0, 12);
    }
    setPhoneNumber(input);
  };

  const handleSubmit = () => {
    if (!phoneNumber || !password) {
      alert(t('Ähli meýdançany doldyrmak hökmany!'));
    } else {
      alert('Üstünlikli ugradyldy!');
    }
  };

  return (
    <GlobalLayout
      title={`${t('log_in')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords=""
    >
      <div className='mb-20'>
        <Layout
          title={t('log_in')}
          layoutBgImg={layoutBgImg}
        />
        <div className='flex justify-center w-full'>
          <div className='bg-white xl:p-8 mt-8 xl:w-[40%]
                        dark:bg-dark-box w-[90%] p-4'>
            <h1 className='text-center font-bold 
                        dark:text-white mb-1 text-4xl'>
              {t('log_in')}
            </h1>
            <p className='text-center text-text text-sm
                        dark:text-dark-text mt-2'>
              {t('please')}
            </p>

            {/* phone */}
            <div className="relative mt-6">
              <label className='flex items-center gap-1 text-sm
                              dark:text-dark-text'>
                <Phone style={{ fontSize: '18px', color: '#0039a6' }} />
                {t('phone_number')}
              </label>
              <input
                type="text"
                name="phone"
                placeholder={t('phone_number')}
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                className="w-full px-4 py-2 border dark:text-dark-text
                         border-border bg-secondary mb-2 mt-1 rounded
                          focus:outline-none focus:ring-2 focus:ring-indigo-500                        
                         dark:bg-dark-box dark:border-dark-border"
              />
            </div>

            {/* password */}
            <div className="relative mt-2">
              <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                <Password style={{ fontSize: '18px', color: '#0039a6' }} />
                {t('password')}
              </label>
              <input
                type="password"
                name="phone"
                placeholder={t('password')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border dark:text-dark-text
                         border-border bg-secondary mb-2 mt-1 rounded
                          focus:outline-none focus:ring-2 focus:ring-indigo-500                          
                         dark:bg-dark-box dark:border-dark-border"
              />
            </div>

            <button
              type="button"
              className='text-white bg-primary px-6 
                       w-full mt-6 py-2 rounded'
              onClick={handleSubmit}
            >
              {t('log_in')}
            </button>
            <Link to='/auth/registration'>
              <p className='dark:text-dark-text mt-2'>
                {t('registration')}
              </p>
            </Link>
            <Link to='/auth/forgot'>
              <p className='text-primary dark:text-white mt-1'>
                {t('forgot')}
              </p>
            </Link>
          </div>
        </div>
      </div>
    </GlobalLayout>
  )
}

export default Login